export const PAGE_SIZE = 10
export const PAGE_SIZE_DEMO = 2
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 40, 50, 60, 80, 100]
export const PAGE_SIZE_OPTIONS_DEMO = [2, 4, 6, 8, 10, 12, 14, 16]
export const POSITION_TABLE = ['bottomLeft']
export const FILTER_COL_HEIGHT = ''
export const FILTER_SIZE = ''